import { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import AuthContext from '../contexts/AuthContext';
import api from '../utils/api';

/**
 * Registers a response interceptor on the shared axios instance so that any
 * request returning 401 Unauthorized clears the local session and redirects
 * to /login. Request-side token attachment happens in utils/api.js; doing it
 * again here would be redundant — and an earlier version's "reject if no
 * token" request-side check broke the login POST itself (there is no token
 * yet when the user is actively signing in).
 */
export function useAxiosInterceptor() {
  const { logout } = useContext(AuthContext);
  const navigate = useNavigate();

  useEffect(() => {
    const responseInterceptor = api.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response && error.response.status === 401) {
          logout();
          navigate('/login', { replace: true });
        }
        return Promise.reject(error);
      }
    );

    return () => {
      api.interceptors.response.eject(responseInterceptor);
    };
  }, [logout, navigate]);
}
